import { Agenda, AgendaProps, EventCard, EventData, Tag } from "@kalyzee/escaet-ui";
import { MeetingOutputDTO, TimeEventOutputDTO } from "@kalyzee/kast-web-sdk/http";
import { isArray } from "lodash";

export interface TimeEventsAgendaProps {
  timeEvents?: TimeEventOutputDTO | TimeEventOutputDTO[];
  selectedEventId?: string;
  kind?: AgendaProps["kind"];
  onSelectEvent?: (eventId: string) => void;
  onJoinEvent?: (eventId: string) => void;
}

export const convertTimeEvent = (event: TimeEventOutputDTO): EventData<MeetingOutputDTO> | undefined => {
  const meeting = event.target as MeetingOutputDTO;
  if (!meeting) return undefined;
  const expert = meeting.actors?.find((a) => a.externalProvider === "escaet:expert");
  return {
    id: event._id,
    logo: "",
    tag: {
      backgroundColor: "#d9eeff",
      textColor: "#0090ff",
      text: "COURS",
    },
    title: meeting.name || "",
    startDatetime: new Date(event.startDatetime),
    endDatetime: new Date(event.endDatetime),
    eventType: "cours",
    expertName: expert?.identity?.username ?? expert?.user?.identity?.username ?? "",
    promotion: (meeting as any).promos?.join(' '),
    data: meeting
  };
}

export const TimeEventsAgenda = ({ timeEvents, selectedEventId, kind, onSelectEvent, onJoinEvent }: TimeEventsAgendaProps) => {

  if (!isArray(timeEvents)) {
    const event = timeEvents ? convertTimeEvent(timeEvents) : undefined;
    if (!event) {
      return (
        <div style={{ width: '100%', borderRadius: '15px', height: '200px', backgroundColor: 'rgb(102 102 102)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'lightgrey'}}>
          L'event ne semble pas exister
        </div>
      )
    }
    return (
      <EventCard
        key={`list-event-${event.id}`}
        id={event.id}
        logo={event.logo}
        tag={
          event.tag?.text && (
            <Tag
              backgroundColor={event.tag?.backgroundColor}
              textColor={event.tag?.textColor}
              className="eventCardTag"
            >
              {event.tag.text}
            </Tag>
          )
        }
        title={event.title}
        startDatetime={event.startDatetime}
        endDatetime={event.endDatetime}
        tagColor={event.tagColor}
        isSelected={true}
        onSelect={onSelectEvent}
        onClickButton={onJoinEvent}
        subtitle={kind === "student" ? event.expertName : undefined}
        actionType={kind === "student" ? "button" : "checkbox"}
        dark={kind === "student"}
      />
    )
  }
  const events: AgendaProps["events"] = [];
  timeEvents?.forEach((event) => {
    const ev = convertTimeEvent(event);
    if (ev) events.push(ev);
  });

  return (
    <Agenda
      events={events}
      selected={selectedEventId ?? null}
      onSelectEvent={(eventId) => onSelectEvent?.(eventId)}
      onJoinEvent={(eventId) => onJoinEvent?.(eventId)}
      kind={kind}
    />
  );
};
